import type { IValues } from '../../../containers/NewLocation/valuesTypes';

import classNames from 'classnames';

import { useState, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { screenedValues } from '../../../tools/constants';
import { useTranslation } from 'react-i18next';



export const Attestation = ({ handler, editable = true }: { handler?: (step: number) => void; editable?: boolean }) => {
    const { values, errors, touched, submitCount } = useFormikContext<IValues>();
    const { t} = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const isFormCompleted = useMemo(() => screenedValues[4].every(field => !errors[field] && touched[field]), [errors, touched]);
    const choices = {
        entry: t('NewLocation.Attestation.entry'),
        proctor: t('NewLocation.Attestation.proctor'),
        stations: t('NewLocation.Attestation.stations'),
        parking: t('NewLocation.Attestation.parking'),
        restroom: t('NewLocation.Attestation.restroom'),
        equipment: t('NewLocation.Attestation.equipment')
    };
    return (
        <div
            className={classNames('cco_collapse', {
                active: isExpanded
            })}>
            <div className="cco_collapse_header">
                <div className="cco_text cco_text_3">
                    <div className="cco_text_inner">
                        <h3>6. {t('NewLocation.Attestation.Attestation')}</h3>

                        <div
                            className={classNames({
                                success: isFormCompleted,
                                error: !isFormCompleted && touched.attestation
                            })}>
                            {isFormCompleted ? t('NewLocation.Attestation.Completed') : submitCount < 1 ? t('NewLocation.Attestation.InProgress') : t('NewLocation.Attestation.FillFields')}
                        </div>
                    </div>
                </div>

                <button type="button" className="cco_collapse_toggle" onClick={() => setIsExpanded(prevState => !prevState)}>
                    <span className="cco_collapse_toggle_text">{ t('NewLocation.Attestation.View')}</span>
                </button>
            </div>

            <div className="cco_collapse_body">
                <div className="cco_collapse_body_inner">
                    {!values.attestation.length && <div className="cco_blurb cco_blurb_error cco_blurb_3">{ t('NewLocation.Attestation.NothingSelected')}</div>}

                    {values.attestation.length > 0 &&
                        (Object.keys(choices) as (keyof typeof choices)[]).map((choice, index) => (
                            <div
                                className={classNames('cco_blurb cco_blurb_3', {
                                    cco_blurb_success: values.attestation.includes(choice),
                                    cco_blurb_error: !values.attestation.includes(choice)
                                })}
                                key={index}>
                                {choices[choice]}
                            </div>
                        ))}

                    {editable && (
                        <div className="cco_btn cco_btn_2">
                            <a
                                href="#"
                                onClick={e => {
                                    handler?.(4);
                                    e.preventDefault();
                                }}>
                                { t('NewLocation.Attestation.Edit')}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
